var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9299 11.5295C18.7881 13.064 18.2123 14.5263 17.2697 15.7454C16.3271 16.9645 15.0569 17.89 13.6075 18.4135C12.1582 18.937 10.5897 19.0369 9.08567 18.7015C7.58162 18.3662 6.20418 17.6094 5.11454 16.5198C4.02489 15.4301 3.26811 14.0527 2.93274 12.5486C2.59738 11.0446 2.69729 9.47611 3.2208 8.02677C3.74432 6.57743 4.66977 5.30716 5.88887 4.36459C7.10798 3.42203 8.57031 2.84615 10.1048 2.70435C9.20639 3.91974 8.77408 5.41721 8.88648 6.9244C8.99887 8.43159 9.6485 9.84838 10.7172 10.9171C11.7859 11.9858 13.2027 12.6354 14.7099 12.7478C16.2171 12.8602 17.7146 12.4279 18.9299 11.5295V11.5295Z",
    stroke: "#8A2BE2",
    strokeWidth: 1.8029,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoon);
export default __webpack_public_path__ + "static/media/ic-moon.a6b99eeb.svg";
export { ForwardRef as ReactComponent };